// extracted by mini-css-extract-plugin
export default {"container":"miCR4QzuFeyeczjsRR3V","title":"SUVoYU2oaA2opxWIN1pg"};